import {useState, useEffect, useRef} from "react"
import {useTranslation} from "react-i18next"
import {TagsInput} from "react-tag-input-component"
import axios from "axios"
import {API_LEXICONS} from "../../constants/apiUrls"
import {useSessionContext} from "../../reactContext/contextCustomHooks/useSessionContext"
import {useTeamContext} from "../../reactContext/contextCustomHooks/useTeamContext"
import arrowDownIcon from "../../assets/icon/arrow-down.svg"
import arrowRightIcon from "../../assets/icon/arrow-right.svg"
import LoadingComponent from "../../components/loading-component/LoadingComponent"
import isLicenceValidity from "../../tools/isLicenceValidity"

export default function LexiconAccordion({lexiconName, lexiconItems, lexiconID, isDisable}) {
    const {t} = useTranslation()
    const {sessionContext} = useSessionContext()
    const {teamContext} = useTeamContext()
    const [display, isDisplay] = useState()
    const [selected, setSelected] = useState(lexiconItems)
    const [scrollHeight, setScrollHeight] = useState("0px")
    const content = useRef("")
    !isLicenceValidity(teamContext.licenceStartDate, teamContext.licenceEndDate) && (isDisable = true)

    const handleRequest = (data) => {
        setSelected(data)
        const headersRequest = {headers: {Authorization: `Bearer ${sessionContext.idToken}`}}
        axios.put(`${API_LEXICONS}/${lexiconID}/items`, data, headersRequest)
        .catch((error) => {
            console.error("PUT /items: ", error)
        })
    }

    const handleClick = () => {
        setScrollHeight(!display ? `${content.current.scrollHeight + 20}px` : "0px")
        isDisplay(!display)
    }

    useEffect(() => {
        setSelected(lexiconItems ? lexiconItems : [])
    }, [lexiconItems])

    if (!lexiconID || !lexiconName || !lexiconItems) return <LoadingComponent/>
    return (
        <>
        <div className={`lexicon-accordion ${isDisable && "rti-input-disable"}`}>
            <div className="header" onClick={handleClick}>
                <h3>{lexiconName}</h3>
                <img src={display ? arrowDownIcon : arrowRightIcon} alt=""/>
            </div>
            <div ref={content} className={`content ${display && "active"}`} style={{maxHeight: scrollHeight}}>
                <TagsInput
                    disabled={isDisable && true}
                    value={selected}
                    onChange={handleRequest}
                    name="word"
                    placeHolder={!isDisable && t("Add a word")}
                />
            </div>
        </div>
        </>
    )
}